export default __webpack_public_path__ + "static/media/_autor.1109f112.svg";